module.exports = __webpack_public_path__ + "static/media/javascript.05dba317.svg";